export const RESET_DEVICE_MESSAGE = "RESET_DEVICE_MESSAGE";

export const GET_DEVICES = "GET_DEVICES";
export const GET_DEVICES_SUCCESS = "GET_DEVICES_SUCCESS";
export const GET_DEVICES_FAIL = "GET_DEVICES_FAIL";

export const ADD_DEVICES = "ADD_DEVICES";
export const ADD_DEVICES_SUCCESS = "ADD_DEVICES_SUCCESS";
export const ADD_DEVICES_FAIL = "ADD_DEVICES_FAIL";

export const UPDATE_DEVICES = "UPDATE_DEVICES";
export const UPDATE_DEVICES_SUCCESS = "UPDATE_DEVICES_SUCCESS";
export const UPDATE_DEVICES_FAIL = "UPDATE_DEVICES_FAIL";

export const UNPAIR_DEVICES = "UNPAIR_DEVICES";
export const UNPAIR_DEVICES_SUCCESS = "UNPAIR_DEVICES_SUCCESS";
export const UNPAIR_DEVICES_FAIL = "UNPAIR_DEVICES_FAIL";
